<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Beneficiaries
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      .row
        .col-12.p-md-5.bg-secondary
          ValidationObserver(ref="Validation" slim)
            .card
              .card-body
                //- h5.card-title BENEFICIARY INFO
                ValidationProvider(name="benificiary name", :rules="{'required': isBeneficiaryFormRequired}" v-slot="{errors}" slim)
                  .form-group
                    label(for="benificiaryName") Name
                    input.form-control#benificiaryName(:class="{'border-danger': errors.length > 0}" type="text" name="benificiaryName" v-model="form.benificiaryName")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="benificiary relationship", :rules="{'required': isBeneficiaryFormRequired}" v-slot="{errors}" slim)
                  .form-group
                    label(for="benificiaryRelationship") Relationship
                    //- input.form-control#benificiaryRelationship(:class="{'border-danger': errors.length > 0}" type="text" name="benificiaryRelationship" v-model="form.benificiaryRelationship")
                    select.form-control#benificiaryRelationship(:class="{'border-danger': errors.length > 0}" name="benificiaryRelationship" v-model="form.benificiaryRelationship")
                      option(value=""): em -- Select --
                      option(v-for="(opt, index) in ['Sister', 'Brother', 'Father', 'Mother', 'Spouse', 'Husband']", :key="index") {{opt}}
                ValidationProvider(name="benificiary date of birth", :rules="{'required': isBeneficiaryFormRequired}" v-slot="{errors}" slim)
                  .form-group
                    label(for="benificiaryDateOfBirth") Date of Birth
                    //- input.form-control#benificiaryDateOfBirth(:class="{'border-danger': errors.length > 0}" type="text" name="benificiaryDateOfBirth" v-model="form.benificiaryDateOfBirth")
                    date-picker.w-100(v-model="form.benificiaryDateOfBirth" valueType="format", :input-class="['form-control', (errors.length > 0 ?'border-danger': '')]")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="benificiary address", :rules="{'required': isBeneficiaryFormRequired}" v-slot="{errors}" slim)
                  .form-group
                    label(for="benificiaryAddress") Address
                    //- input.form-control#benificiaryAddress(:class="{'border-danger': errors.length > 0}" type="text" name="benificiaryAddress" v-model="form.benificiaryAddress")
                    textarea.form-control(:class="{'border-danger': errors.length > 0}", v-model="form.benificiaryAddress" name="benificiaryAddress")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                
                h4.mb-3 IDENTIFICATION
                ValidationProvider(name="identification type", :rules="{'required': isBeneficiaryFormRequired}" v-slot="{errors}" slim)
                  .input-group
                    .input-group-prepend
                      span.input-group-text Type
                    input.form-control(:class="{'border-danger': errors.length > 0}" type="text" v-model="form.benificiaryIDType")
                  small.d-block.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="identification number", :rules="{'required': isBeneficiaryFormRequired}" v-slot="{errors}" slim)
                  .input-group.mt-3
                    .input-group-prepend
                      span.input-group-text Number
                    input.form-control(:class="{'border-danger': errors.length > 0}" type="text" v-model="form.benificiaryIDNumber")
                  small.d-block.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="identification issue date", :rules="{'required': isBeneficiaryFormRequired}" v-slot="{errors}" slim)
                  .input-group.mt-3
                    .input-group-prepend
                      span.input-group-text Issue Date
                    //- input.form-control(:class="{'border-danger': errors.length > 0}" type="text" v-model="form.benificiaryIssueDate")
                    date-picker(style="flex:auto" v-model="form.benificiaryIssueDate" valueType="format", :input-class="['form-control', (errors.length > 0 ?'border-danger': '')]")
                  small.d-block.text-danger(v-if="errors.length") {{ errors[0] }}.
                .row.mt-3
                  .col-12.text-right
                    button.btn.btn-danger.mr-2 CLEAR
                    button.btn.btn-primary(type="button" @click.prevent="send('VALIDATE')", :disabled="state.matches('validate')") ADD BENIFICIARY
        .col-12.py-3
          .row
            .col-12(v-if="value.length == 0")
              .card.border-secondary
                .card-body
                  p.text-center: em There are no benifiary added.
            .col-12(v-for="(b, index) in value", :key="index")
              .card.border-secondary
                .card-body
                  h5.card-title Beneficiary \#{{ index+1 }}
                    button.close(@click.prevent="removeList(index)")
                      span &times;
                  .input-group.mb-3
                    .input-group-prepend
                      span.input-group-text Name
                    p.form-control-plaintext.border.pl-2 {{b.benificiaryName}}
                  .input-group.mb-3
                    .input-group-prepend
                      span.input-group-text Relationship
                    p.form-control-plaintext.border.pl-2 {{b.benificiaryRelationship}}
                  .input-group.mb-3
                    .input-group-prepend
                      span.input-group-text Date of Birth
                    p.form-control-plaintext.border.pl-2 {{b.benificiaryDateOfBirth}}
                  .input-group.mb-3
                    .input-group-prepend
                      span.input-group-text Address
                    p.form-control-plaintext.border.pl-2 {{b.benificiaryAddress}}
                  .input-group.mb-3
                    .input-group-prepend
                      span.input-group-text ID Type
                    p.form-control-plaintext.border.pl-2 {{b.benificiaryIDType}}
                  .input-group.mb-3
                    .input-group-prepend
                      span.input-group-text ID Number
                    p.form-control-plaintext.border.pl-2 {{b.benificiaryIDNumber}}
                  .input-group.mb-3
                    .input-group-prepend
                      span.input-group-text ID Issue Date
                    p.form-control-plaintext.border.pl-2 {{b.benificiaryIssueDate}}

                  button.btn.btn-sm.btn-danger.float-right(type="button", @click.prevent="removeList(index)") Remove
</template>

<style scoped=""></style>

<script>
import { ref, reactive, computed } from '@vue/composition-api';
import { createMachine } from 'xstate';
import { useMachine } from 'xstate-vue2';
const Machine = createMachine(require('./step_5.state').default);

export default {
  name: 'Beneficiary',
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  emits: ['prev', 'input'],

  setup(props, { emit }) {
    const list = reactive(props.value);
    const form = reactive({
      benificiaryName: '',
      benificiaryRelationship: '',
      benificiaryDateOfBirth: '',
      benificiaryAddress: '',
      benificiaryIDType: '',
      benificiaryIDNumber: '',
      benificiaryIssueDate: '',
    });
    const Validation = ref(null);
    const prev = () => {
      emit('prev');
    };
    const next = () => {
      emit('next');
    };
    const validate = () => {
      // emit('input', form)
      return Validation.value.validate().then((success) => {
        if (success) {
          return Promise.resolve(success);
        }
        return Promise.reject(success);
      });
    };
    const { send, state } = useMachine(Machine, {
      actions: {
        /**
         * [addToList description]
         * @param {[type]} ctx   [description]
         * @param {[type]} event [description]
         */
        addToList() {
          list.push(form);
        },
      },
      services: {
        /**
         * [validating description]
         * @param  {[type]} ctx   [description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        validating() {
          return validate();
        },
      },
    });
    const isBeneficiaryFormRequired = computed(() => {
      return (
        !!form.benificiaryName ||
        !!form.benificiaryRelationship ||
        !!form.benificiaryDateOfBirth ||
        !!form.benificiaryAddress ||
        !!form.benificiaryIDType ||
        !!form.benificiaryIDNumber ||
        !!form.benificiaryIssueDate
      );
    });
    const removeList = (index) => {
      const list = props.value;
      list.splice(index, 1);
      emit('input', list);
    };
    return {
      next,
      prev,
      removeList,
      isBeneficiaryFormRequired,
      form,
      Validation,
      send,
      state,
      validate,
    };
  },
};
</script>
